export default "__VITE_ASSET__CuTbBtqO__"